<style lang="scss" scoped>
.simple-search {
	&__form {
		display: flex;
		align-items: flex-end;
	}
	&__input {
		flex: 1;
	}
	&__button {
		margin-left: 5px;
		width: 150px;
		button {
			width: 100%;
		}
	}
}
</style>

<template lang="pug">
    .simple-search
        el-form.simple-search__form(:model='form', @submit.native.prevent="handleSubmit")
            div.simple-search__input 
                el-form-item(label='Search school name, URN, DfE code or ACARA ID')
                    el-input(v-model='form.term', ref="autofocus", placeholder='Enter search term', size="medium")
            div.simple-search__button
                el-form-item
                    el-button(type="primary", icon="el-icon-search", :disabled="!form.term", :loading="state == 'loading'", native-type="submit", size="medium") {{ state == 'loading' ? 'Searching' : 'Search'}}
</template>

<script>
import gql from "graphql-tag";

export default {
	name: "SimpleSearch",
	mounted() {
		this.$nextTick(function() {
			this.$refs.autofocus.$el.children[0].focus();
		});
	},
	props: {
		associatedOnly: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		state: "ready",
		form: {
			term: ""
		}
	}),
	methods: {
		async handleSubmit() {
			this.state = "loading";
			this.exclude_demo = true;
			try {
				const results = await this.$apollo.query({
					query: gql`
						query SchoolSearch($term: String, $associated: Boolean, $exclude_demo: Boolean) {
							SchoolSearch(term: $term, associated: $associated, exclude_demo: $exclude_demo) {
								id
								name
								address_postcode
								urn
								la_code
								establishment_number
								country_iso_3166_2
								country_name
								phase_of_education
								demo_company_id
							}
						}
					`,
					variables: {
						term: this.form.term,
						associated: this.associatedOnly,
						exclude_demo: this.exclude_demo
					}
				});

				this.$bus.$emit("search-results", results.data.SchoolSearch);
				this.state = "loaded";
			} catch (err) {
				this.state = "ready";
			}
		}
	}
};
</script>
